export class ResponsiveUtil {
    public static readonly MOBILE_MAX_WIDTH = 800;

}